export default __webpack_public_path__ + "static/media/pic2.d34dd8a7.jpg";